import { decode } from 'html-entities';
const sanitizeCharacterEncodings = (text: string): string => {
    if (!text) {
        return '';
    }
    return decode(text);
};
export { sanitizeCharacterEncodings };
